import createState from "./state";
import { importGetters } from "./getters";
import { importMutations } from "./mutations";
import { importActions } from "./actions";

export const importWizardStore = {
  state: createState(),
  getters: importGetters,
  actions: importActions,
  mutations: importMutations,
};
